import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";
import { FAQ_ITEMS } from "@/lib/faqData";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  // Show the first 6 FAQs on the landing page — the full list lives at /faq
  // and has its own dedicated schema/route.
  const faqs = FAQ_ITEMS.slice(0, 6);
  return (
    <section id="faq" data-testid="faq-section" className="max-w-3xl mx-auto px-4 py-24">
      <div className="text-center">
        <div className="pill mx-auto"><span>FAQ</span></div>
        <h2 className="mt-3 font-display text-4xl sm:text-5xl text-white">Frequently asked questions</h2>
        <p className="mt-3 text-sm text-[var(--fg-muted)]">
          A quick primer. See the <Link to="/faq" className="text-cyan-300 underline">full FAQ</Link> for every answer.
        </p>
      </div>
      <div className="mt-10 space-y-3">
        {faqs.map((f, i) => (
          <div key={f.q} data-testid={`faq-${i}`} className="card-elev overflow-hidden transition-all">
            <button
              onClick={() => setOpen(open === i ? -1 : i)}
              className="w-full flex items-center justify-between px-5 py-4 text-left font-medium text-white"
              aria-expanded={open === i}
            >
              <h3 className="text-base font-semibold m-0">{f.q}</h3>
              <ChevronDown className={`w-4 h-4 transition-transform ${open === i ? "rotate-180" : ""}`} />
            </button>
            {open === i && (
              <div className="px-5 pb-5 text-sm text-[var(--fg-muted)] leading-relaxed">{f.a}</div>
            )}
          </div>
        ))}
      </div>
      <div className="mt-8 text-center">
        <Link to="/faq" className="btn-ghost">View all questions →</Link>
      </div>
    </section>
  );
}

